import styles from "./TrainingSummary.module.css";

export default function MetricCard({
  Icon,
  color,
  value,
  label,
  smallLabel,
  fullWidth = false,
}) {
  return (
    <div
      className={`${styles.metricCard} ${fullWidth ? styles.metricSingle : ""}`}
    >
      {smallLabel && (
        <span className={styles.metricSmallLabel} style={{ color }}>
          {smallLabel}
        </span>
      )}
      <Icon size={24} color={color} className={styles.metricIcon} />
      <p className={styles.metricValue} style={{ color }}>
        {value}
      </p>
      <span className={styles.metricLabel}>{label}</span>
    </div>
  );
}
